export default "__VITE_ASSET__B4OEWx2F__"